class AiImageBadge extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.text = this.querySelector('.ai-image-badge__text');
    if (!this.button || !this.text) return;
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle(!this.classList.contains('expanded'));
    }, options);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  // Same reveal as the size information badge in sections/main-product.liquid.
  toggle(expanded) {
    this.text.hidden = !expanded;
    if (expanded) this.text.getBoundingClientRect();
    this.classList.toggle('expanded', expanded);
    this.button.setAttribute('aria-expanded', String(expanded));
  }
}
if (!customElements.get('ai-image-badge')) customElements.define('ai-image-badge', AiImageBadge);
